import React, { useEffect, useState } from "react";
import api from "../api";
import AdminNavbar from "./AdminNavbar";
import { useNavigate } from "react-router-dom";
import StatCard from "./dashboard/StatCard";
import Leaderboard from "./dashboard/Leaderboard";
import StatsGraph from "./dashboard/StatsGraph";
import ProgressCard from "./dashboard/ProgressCard";
import ExportOptions from "./dashboard/ExportOptions";

export default function AdminDashboard() {
  const [recentRegistrations, setRecentRegistrations] = useState([]);
  const [recentAttendance, setRecentAttendance] = useState([]);
  const [attended, setAttended] = useState(0);
  const [notAttended, setNotAttended] = useState(0);
  const [totalRegistered, setTotalRegistered] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const res = await api.get("/admin/stats");
      const users = res.data.users;
      setAttended(res.data.attended);
      setNotAttended(res.data.notAttended);
      setTotalRegistered(users.length);
      setRecentRegistrations(users.slice(-5).reverse());
      setRecentAttendance(
        users
          .filter((u) => u.attended)
          .slice(-5)
          .reverse()
      );
    } catch (err) {
      console.error("Failed to fetch stats", err);
    }
  };

  return (
    <div className="dashboard-wrapper">
      <AdminNavbar />
      <h2 className="dashboard-heading">Admin Dashboard</h2>

      <div className="stat-cards-grid">
        <StatCard title="Registered" value={totalRegistered} color="blue" />
        <StatCard title="Attended" value={attended} color="green" />
        <StatCard title="Not Attended" value={notAttended} color="red" />
      </div>

      <div className="dashboard-chart-section">
        <StatsGraph />
        <ProgressCard />
      </div>

      <div className="dashboard-leader-export">
        <Leaderboard
          title="Top Attendees"
          data={recentAttendance.map((user) => ({
            id: user._id,
            name: user.name,
            score: 1, // or any real score logic if available
          }))}
        />

        <ExportOptions />
      </div>

      <div className="dashboard-tables">
        <div className="dashboard-table-box">
          <h3 className="dashboard-table-heading">Recent Registrations</h3>
          <table className="dashboard-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>College ID</th>
              </tr>
            </thead>
            <tbody>
              {recentRegistrations.map((user, idx) => (
                <tr key={idx}>
                  <td>{user.name}</td>
                  <td>{user.collegeId}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button
            className="dashboard-see-more"
            onClick={() => navigate("/admin/records")}
          >
            See more...
          </button>
        </div>

        <div className="dashboard-table-box">
          <h3 className="dashboard-table-heading">Recent Attendance</h3>
          <table className="dashboard-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>College ID</th>
              </tr>
            </thead>
            <tbody>
              {recentAttendance.map((user, idx) => (
                <tr key={idx}>
                  <td>{user.name}</td>
                  <td>{user.collegeId}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button
            className="dashboard-see-more"
            onClick={() => navigate("/admin/records")}
          >
            See more...
          </button>
        </div>
      </div>
    </div>
  );
}
